import { Autocomplete, Avatar, Badge, Button, Chip, TextField, Typography, useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { CommonHelper } from 'src/utils/commonHelper';
import { CommonFunction } from 'src/utils/commonFunctions/common-function.component';
import { Key as KeyIcon } from '@mui/icons-material';
import FacebookIcon from '../../assets/facebook.svg';
import BlueskyIcon from '../../assets/bluesky.svg';
import GBusinessIcon from '../../assets/google-my-business-logo.svg';
import InstagramIcon from '../../assets/instagram.svg';
import LinkedInIcon from '../../assets/linked_in.svg';
import TikTokIcon from '../../assets/tiktok.svg';
import TwitterIcon from '../../assets/twitter.svg';
import YoutubeIcon from '../../assets/youtube.png';
import SnapChatIcon from '../../assets/snapchat.svg';
import PinterestIcon from '../../assets/pinterest-icon.svg'
import ThreadsIcon from '../../assets/threads.svg'
import { PostUtil } from '../new-post-new/post-util';
import { useTranslation } from 'react-i18next';

const ConnectedMediaComponent = ({
  selectedSocialMedias,
  configuredSocialMedia,
  handleNetworks,
  handleProfileClick,
  handleDisabled = null,
  disabledProfilesIds = [],
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t: translate } = useTranslation();
  const hasIntegratationPermission = CommonHelper.CheckForPermissionAvailableForUser(
    CommonHelper.PermissionList.INTEGRATE_PERMISSION
  );
  let fbColor = theme.palette.preview.facebook.color;
  let instaColor = theme.palette.preview.instagram.color;
  const GroupHeader = styled('div')(({ theme }) => ({
    top: '-8px',
    padding: '20px 10px',
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
  }));
  const GroupItems = styled('ul')({
    padding: 0,
  });
  return (
    <Autocomplete
      multiple
      disabled={handleDisabled ? handleDisabled() : false}
      disableCloseOnSelect
      id="grouped-demo"
      options={configuredSocialMedia}
      groupBy={(option) => option.service_name.toUpperCase()}
      getOptionLabel={(option) => (option.profile_name ? option.profile_name : option.id)}
      renderOption={(props, option) => {
        const isDisabled = disabledProfilesIds.includes(option.id);
        const isInactive = !option.is_active;
        return (
          <li
          {...props}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
          sx={{
            '&:hover': {
              backgroundColor: !isDisabled && !isInactive ? theme.palette.action.hover : 'transparent'
            }
          }}
        >
          <div style={{ opacity: isDisabled || isInactive ? 0.5 : 1, flex: 1 }}>
            {CommonFunction.InitialAccountBadgeWithName(option)}
          </div>
          {isInactive && (
            <Button
              variant="contained"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                if (hasIntegratationPermission) {
                  handleProfileClick(option);
                }
              }}
              sx={{
                ml: 2,
                borderRadius: 1,
                backgroundColor: theme.palette.error.main,
                color: theme.palette.error.contrastText,
                '&:hover': {
                  backgroundColor: theme.palette.error.dark,
                  boxShadow: theme.shadows[3],
                }
              }}
              startIcon={<KeyIcon fontSize="small" />}
            >
              Re-authenticate
            </Button>
          )}
        </li>
        );
      }}
      renderGroup={(params) => (
        <li key={params.key}>
          {CommonHelper.GetServiceLabelView(params.group)}
          <GroupItems>{params.children}</GroupItems>

        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={selectedSocialMedias && selectedSocialMedias.length > 0 ? '' : translate('service.select_your_profile', 'Select Your Profile')}
          inputProps={{
            ...params.inputProps,
            readOnly: isMobile ? true : false,
          }}
        />
      )}
      onChange={(e, values) => {
        const selectableValues = values.filter(option => option.is_active); 
        handleNetworks(selectableValues);
      }}
      value={selectedSocialMedias}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            key={option.id}
            avatar={
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                badgeContent={CommonHelper.GetSocialMediaAvatar(option.service_name)}
                sx={{
                  '& .MuiBadge-badge': {
                    height: 20,
                    width: 20,
                    minWidth: 20,
                    borderRadius: '50%',
                    bgcolor:  'white', 
                    border: '2px solid white', // adds a border for better separation
                    margin: '-4px', // adds slight spacing between badge and avatar
                  },
                }}
              >
                <Avatar
                  src={option.profile_image ? option.profile_image : option.profile_name || option.id}
                  alt={option.profile_name ? option.profile_name : option.id}
                  sx={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    height: 30,
                    width: 30,
                    bgcolor: 'primary.main',
                  }}
                />
              </Badge>
            }
            label={option.profile_name || option.id}
            sx={{
              ml: 1, // adds some space between avatar and label
              '& .MuiChip-label': {
                marginLeft: '6px', // add more space between avatar and label if needed
              },
            }}
            {...getTagProps({ index })}
          />
        ))
      }
    />
  );
};
export default ConnectedMediaComponent;
